import React, { Component } from 'react';

class FormFieldHeader extends Component {

	constructor() {
		super();
		this.state = {
			hover: false
		}
		this.onHover = this.onHover.bind(this);
		this.onLeave = this.onLeave.bind(this);
	}

	onHover() {
		this.setState({hover: true})
	}

	onLeave() {
		this.setState({hover: false})
	}

	render() {
		return(
			<div>
				<h5>
					{this.props.header}
					{this.props.help ? 
					<i 	className="material-icons"
						onMouseEnter={this.onHover}
						onMouseLeave={this.onLeave}>
						{this.state.hover ? "help" : "help_outline"}
					</i> : null}
				</h5>
				{this.state.hover ? 
				<div className="mdl-card mdl-shadow--2dp overlapping">
					<div className="mdl-card__supporting-text">
						{this.props.help}
					</div>
				</div> : null}
			</div>
		);
	}

}

export default FormFieldHeader


// WEBPACK FOOTER //
// ./src/components/form/FormFieldHeader.js